import { render, staticRenderFns } from "./DesktopMain.vue?vue&type=template&id=6fb2bfd6&"
import script from "./DesktopMain.vue?vue&type=script&lang=js&"
export * from "./DesktopMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports